import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "ready-bots",
  class: "mt-4 px-3"
}
const _hoisted_2 = {
  key: 1,
  class: "text-md text-gray-600 dark:text-white/75 font-semibold text-left"
}
const _hoisted_3 = { class: "flex items-center mt-4" }
const _hoisted_4 = { class: "flex items-center w-full" }
const _hoisted_5 = { class: "px-0 py-2" }
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = { class: "flex items-start justify-between" }
const _hoisted_8 = { class: "text-sm text-gray-600 dark:text-white/75 font-semibold text-left w-7/12" }
const _hoisted_9 = { class: "w-5/12 flex justify-end items-center text-gray-600 dark:text-white/75 text-xs whitespace-nowrap" }
const _hoisted_10 = { class: "uppercase pr-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "px-2 opacity-60" }, "/", -1)
const _hoisted_12 = { class: "uppercase pl-2" }
const _hoisted_13 = { class: "py-3 h-full" }
const _hoisted_14 = { class: "h-[calc(100%-58px)] overflow-y-auto" }
const _hoisted_15 = {
  key: 0,
  class: "flex items-end text-[12px] font-semibold"
}
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-200 dark:border-gray-600 border-dashed mx-2 mb-1 flex-grow min-w-[50px]" }, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "flex items-end text-xs"
}
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-200 dark:border-gray-600 border-dashed mx-2 mb-1 flex-grow min-w-[50px]" }, null, -1)
const _hoisted_21 = {
  key: 2,
  class: "flex items-end text-xs"
}
const _hoisted_22 = { class: "text-left" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-200 dark:border-gray-600 border-dashed mx-2 mb-1 flex-grow min-w-[50px]" }, null, -1)
const _hoisted_24 = { class: "uppercase text-xs opacity-70 whitespace-nowrap" }
const _hoisted_25 = {
  key: 3,
  class: "flex items-end text-xs"
}
const _hoisted_26 = { class: "text-left" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-200 dark:border-gray-600 border-dashed mx-2 mb-1 flex-grow min-w-[50px]" }, null, -1)
const _hoisted_28 = {
  key: 4,
  class: "flex items-end text-xs"
}
const _hoisted_29 = { class: "text-left" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-200 dark:border-gray-600 border-dashed mx-2 mb-1 flex-grow min-w-[50px]" }, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "flex items-end text-xs"
}
const _hoisted_32 = { class: "text-left" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-200 dark:border-gray-600 border-dashed mx-2 mb-1 flex-grow min-w-[50px]" }, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "text-red-500 px-1"
}
const _hoisted_35 = {
  key: 6,
  class: "flex items-end text-xs"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-200 dark:border-gray-600 border-dashed mx-2 mb-1 flex-grow min-w-[50px]" }, null, -1)
const _hoisted_37 = { class: "mt-6 px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_skeleton = _resolveComponent("n-skeleton")!
  const _component_ArrowLeft12Regular = _resolveComponent("ArrowLeft12Regular")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ArrowRight12Regular = _resolveComponent("ArrowRight12Regular")!
  const _component_rb_coin = _resolveComponent("rb-coin")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_rb_switch = _resolveComponent("rb-switch")!
  const _component_bot_review = _resolveComponent("bot-review")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.dashBoard.localization)
      ? (_openBlock(), _createBlock(_component_n_skeleton, {
          key: 0,
          class: "inline-block",
          width: 215,
          height: 20,
          sharp: false
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.dashBoard.localization?.dashboard_marketplace_ready_bots_title), 1)),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_n_button, {
          circle: "",
          secondary: "",
          id: "prev-exchange",
          class: _normalizeClass(["mr-2", _ctx.exchangesFromRecords.length && _ctx.exchangesFromRecords.length > 2 ? '' : 'hidden'])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_icon, {
              size: "15",
              class: "text-gray-600 dark:text-white/75"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowLeft12Regular)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_swiper, {
          "slides-per-view": 2,
          "space-between": 8,
          navigation: {
                    nextEl: '#next-exchange',
                    prevEl: '#prev-exchange',
                },
          class: "w-full"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exchangesFromRecords, (exchange) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, { key: exchange }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_card, {
                    size: "small",
                    class: _normalizeClass(["bg-white dark:bg-darkCardBg rounded-lg cursor-pointer border-[1px] hover:border-main", _ctx.currentEchangeId == exchange ? 'border-main shadow' : 'border-transparent']),
                    bordered: false,
                    segmented: {
                            content: true,
                            footer: 'soft'
                        },
                    onClick: _withModifiers(($event: any) => (_ctx.currentEchangeId = exchange), ["prevent"]),
                    "content-style": "padding: 0;"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["rb-td-stock-icon m-0 h-4", `rb-td-stock-icon-${_ctx.getExchange(exchange)?.code_name}`])
                        }, null, 2)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_n_button, {
          circle: "",
          secondary: "",
          id: "next-exchange",
          class: _normalizeClass(["ml-2", _ctx.exchangesFromRecords.length && _ctx.exchangesFromRecords.length > 2 ? '' : 'hidden'])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_icon, {
              size: "15",
              class: "text-gray-600 dark:text-white/75"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowRight12Regular)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createVNode(_component_swiper, {
        "slides-per-view": 1,
        "space-between": 8,
        navigation: {
                nextEl: '#next-bot',
                prevEl: '#prev-bot',
            },
        class: "w-full"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.botsList, (bot) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: bot.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_card, {
                  size: "small",
                  class: _normalizeClass(["bg-white dark:bg-darkCardBg rounded-lg", _ctx.getExchange(bot.exchange).futures == 1 ? 'h-[380px]': 'h-[320px]']),
                  bordered: false,
                  segmented: {
                        content: true,
                        footer: 'soft'
                    },
                  "content-style": "padding: 0; overflow-y: hidden;"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("section", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(bot.name), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(bot.pair.split('/')[0]), 1),
                        _createVNode(_component_rb_coin, {
                          class: "w-4 h-4",
                          coin: _ctx.getCurrency(bot.pair.split('/')[0])
                        }, null, 8, ["coin"]),
                        _hoisted_11,
                        _createVNode(_component_rb_coin, {
                          class: "w-4 h-4",
                          coin: _ctx.getCurrency(bot.pair.split('/')[1])
                        }, null, 8, ["coin"]),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(bot.pair.split('/')[1]), 1)
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsList, (column) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: column.name,
                            class: "text-gray-600 dark:text-white/75 mb-3 mt-1 break-words px-3"
                          }, [
                            (column.name == 'profit')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(column.title), 1),
                                  _hoisted_17,
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["font-black text-right whitespace-nowrap text-[14px]", bot.profit > 0 ? 'text-green-600' : 'text-red-500'])
                                  }, _toDisplayString(bot.profit > 0 ? '+' : '') + _toDisplayString(bot.profit) + " % ", 3)
                                ]))
                              : (column.name == 'algo')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, _toDisplayString(column.title), 1),
                                    _hoisted_20,
                                    _createVNode(_component_n_tag, {
                                      round: "",
                                      size: "small",
                                      class: "font-semibold",
                                      type: bot.algo == 'long' ? 'success' : 'error'
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(bot.algo), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["type"])
                                  ]))
                                : (column.name == 'depo')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      _createElementVNode("div", _hoisted_22, _toDisplayString(column.title), 1),
                                      _hoisted_23,
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["font-semibold flex items-center justify-end", bot[column.name]?.length > 20 ? 'whitespace-normal' : 'whitespace-nowrap'])
                                      }, [
                                        _createTextVNode(_toDisplayString(bot[column.name]) + " ", 1),
                                        _createElementVNode("div", _hoisted_24, " " + _toDisplayString(bot._depo_symbol) + " ", 1),
                                        _createVNode(_component_rb_coin, {
                                          class: "w-4 h-4",
                                          coin: _ctx.getCurrency(bot._depo_symbol)
                                        }, null, 8, ["coin"])
                                      ], 2)
                                    ]))
                                  : (column.name == 'autoswitcher')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, _toDisplayString(column.title), 1),
                                        _hoisted_27,
                                        _createVNode(_component_rb_switch, {
                                          disabled: "",
                                          value: bot[column.name]
                                        }, null, 8, ["value"])
                                      ]))
                                    : (column.name == 'exchange')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                          _createElementVNode("div", _hoisted_29, _toDisplayString(column.title), 1),
                                          _hoisted_30,
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["rb-td-stock-icon m-0 h-4", `rb-td-stock-icon-${_ctx.getExchange(bot.exchange)?.code_name}`])
                                          }, null, 2)
                                        ]))
                                      : (column.name == 'leverage')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                            (_ctx.getExchange(bot.exchange).futures == 1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                  _createElementVNode("div", _hoisted_32, _toDisplayString(column.title), 1),
                                                  _hoisted_33,
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["font-semibold text-right", bot[column.name]?.length > 20 ? 'whitespace-normal' : 'whitespace-nowrap'])
                                                  }, [
                                                    (String(bot[column.name]).toLowerCase() != 'na')
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, "X"))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(" " + _toDisplayString(bot[column.name]), 1)
                                                  ], 2)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["text-left", column.title.length > 20 ? 'whitespace-normal' : 'whitespace-nowrap'])
                                            }, _toDisplayString(column.title), 3),
                                            _hoisted_36,
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["font-semibold text-right", bot[column.name]?.length > 20 ? 'whitespace-normal' : 'whitespace-nowrap'])
                                            }, _toDisplayString(bot[column.name]), 3)
                                          ]))
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_n_button, {
                          strong: "",
                          secondary: "",
                          class: "rounded-md w-full",
                          loading: bot.loading,
                          disabled: bot.loading,
                          onClick: ($event: any) => (_ctx.buyBot(bot))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.actionColumn.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["loading", "disabled", "onClick"])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    (_ctx.marketplace.refsLocalizationNotEmpty)
      ? (_openBlock(), _createBlock(_component_bot_review, {
          key: 2,
          withFilters: "",
          mode: "dashboard",
          show: _ctx.showModal
        }, null, 8, ["show"]))
      : _createCommentVNode("", true)
  ]))
}